import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-search-input',
	template: `
		<div class="client-details__block">
			<div class="input-wrapper">
				<mat-form-field dir="rtl">
					<mat-label>חיפוש</mat-label>
					<input matInput dir="rtl" placeholder="חיפוש" [formControl]="searchControl" />
					<button mat-icon-button matSuffix [ngClass]="{ visible: searchControl.value }" (click)="searchControl.reset()">
						<mat-icon color="error">cancel</mat-icon>
					</button>
				</mat-form-field>
			</div>
		</div>
	`,
	styles: [
		`
			@use '../../../variables' as *;
			@use '../../../mixins' as *;
			button {
				opacity: 0;
				transition: opacity 0.2s ease-out;

				&.visible {
					opacity: 1;
					transition: opacity 0.1s ease-in-out;
				}
			}

			.client-details__block {
				border-bottom: 1px solid #e8e8e8;
				background-color: #ffffff;
				position: sticky;
				top: 0;
				z-index: 2;

				& .input-wrapper {
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: flex-end;
					min-height: 104px;
				}
			}

			mat-form-field {
				text-align: right;
				scale: 1.6;
			}
			@media screen and (max-width: $breakpoint-mobile) {
				.client-details__block {
					& .input-wrapper {
						min-height: 80px;
					}
				}

				mat-form-field {
					scale: 1.2;
				}
			}
		`,
	],
})
export class SearchInputComponent {
	constructor() {}

	searchControl = new FormControl('', { nonNullable: true });
	// searchValueChanges = new EventEmitter<Observable<string>>();

	get valueChanges(): Observable<string> {
		return this.searchControl.valueChanges;
	}
}
